import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { PortalDashboardObject } from "@ServerTypes/portal/portal.schema";

interface HelpSectionState {
  display: boolean;
  module: string;
}

// Portal dashboard modal state — purely frontend UI state
interface PortalDashboardDataState {
  isModalVisible: boolean;
  title: string;
  component: string | null;
}

const initialPortalDashboardDataState: PortalDashboardDataState = {
  isModalVisible: false,
  title: "",
  component: null,
};

const portalDashboardDataSlice = createSlice({
  name: "portalDashboardData",
  initialState: initialPortalDashboardDataState,
  reducers: {
    setPortalData: (_state: PortalDashboardDataState, action: PayloadAction<PortalDashboardDataState>) => action.payload,
    setModalVisiblity: (state: PortalDashboardDataState, action: PayloadAction<Partial<PortalDashboardDataState>>) => ({
      ...state,
      ...action.payload,
    }),
  },
});

const helpSectionStateSlice = createSlice({
  name: "helpSectionState",
  initialState: { display: false, module: "general" } as HelpSectionState,
  reducers: {
    setHelpSectionState: (_state: HelpSectionState, action: PayloadAction<HelpSectionState>) => action.payload,
  },
});

const reducerHeaderSlice = createSlice({
  name: "reducerHeader",
  initialState: true,
  reducers: {
    setReduceHeader: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

const portalDashboardObjectSlice = createSlice({
  name: "portalDashboardObject",
  initialState: {} as PortalDashboardObject,
  reducers: {
    setPortalDashboardObject: (_state: PortalDashboardObject, action: PayloadAction<PortalDashboardObject>) => action.payload,
  },
});

export const { setPortalData, setModalVisiblity } = portalDashboardDataSlice.actions;
export const { setPortalDashboardObject } = portalDashboardObjectSlice.actions;
export const { setHelpSectionState } = helpSectionStateSlice.actions;
export const { setReduceHeader } = reducerHeaderSlice.actions;

export const portalDashboardData = portalDashboardDataSlice.reducer;
export const helpSectionState = helpSectionStateSlice.reducer;
export const onReduceHeader = reducerHeaderSlice.reducer;
export const portalDashboardObject = portalDashboardObjectSlice.reducer;

export default portalDashboardDataSlice.reducer;
